import { Directive } from '@angular/core';
import { CanComponentDeactivate } from './can-deactivate.interface';

@Directive()
export abstract class CampaignStepBase implements CanComponentDeactivate {
    protected previewMode = false;
    protected editMode = false;

    canDeactivate(): boolean {
        return this.previewMode && !this.editMode;
    }

    getExitMessage?(): string;

    abstract saveDraft(): Promise<boolean>;
}
